import TicketFeedbackRating from './TicketFeedbackRating';

export * from './TicketFeedbackRating.types';
export default TicketFeedbackRating;
